import { render, staticRenderFns } from "./Provinces.vue?vue&type=template&id=49b9dbb0&"
import script from "./Provinces.vue?vue&type=script&lang=js&"
export * from "./Provinces.vue?vue&type=script&lang=js&"
import style0 from "./Provinces.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

component.options.__file = "Provinces.vue"
export default component.exports